export function Heading({ as: Tag = "h1", children, className }) {
  const tag = Tag.toLowerCase();
  if (tag.includes("heading")) {
    const headingNumber = tag.replace("heading", "");
    Tag = `h${headingNumber}`;
  }

  return (
    <Tag className={className} >
      {children}
    </Tag>
  );
}
